import { render, staticRenderFns } from "./IndicateFriends.vue?vue&type=template&id=6377f0c5&"
import script from "./IndicateFriends.js?vue&type=script&lang=js&"
export * from "./IndicateFriends.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports